// Routes match the old Wix site's URLs so existing links & search results keep working
export const PAGE_ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  PROJECT: "/:projectSlug",
  EVENT: "/event-details/:eventSlug",
  WISHLIST: "/wishlist",
  PRODUCT: "/product-page/:productSlug",
  CONTACT: "/contactus",
  CART: "/cart-page",
  ORDER_RESULT: "/order/:result",
};

export const getProductRoute = (slug) => (
  PAGE_ROUTES.PRODUCT.replace(":productSlug", slug)
);

export const getEventRoute = (slug) => (
  PAGE_ROUTES.EVENT.replace(":eventSlug", slug)
);

export const ADMIN_PAGE_ROUTES = {
  HOME: "/admin",
  ORDERS: "/admin/orders",
  ORDER: "/admin/orders/:orderID",
  PRODUCTS: "/admin/products",
  PRODUCT: "/admin/products/:productID",
  SUBSCRIBERS: "/admin/subscribers",
  ANALYTICS: "/admin/analytics",
  ACCOUNT: "/admin/account",
};

export const getAdminOrderRoute = (orderID) => (
  ADMIN_PAGE_ROUTES.ORDER.replace(":orderID", orderID)
);

//"new" opens an empty product form
export const getAdminProductRoute = (productID) => (
  ADMIN_PAGE_ROUTES.PRODUCT.replace(":productID", productID)
);

export const CONTACT_DETAILS = {
  EMAIL: "communityassistingschools@gmail.com",
  WHATSAPP: "https://api.whatsapp.com/send?phone=27636751967",
  ADDRESS: ["Houghton , Johannesburg,", "Gauteng South Africa"],
  INSTAGRAM: "https://www.instagram.com/communityassistingschools/",
  FACEBOOK: "https://www.facebook.com/profile.php?id=61559684811767",
  LINKEDIN: "https://za.linkedin.com/company/community-assisting-schools-cas",
  //CAS's own Yoco payment link for general (any amount) donations
  DONATE: "https://pay.yoco.com/community-assisting-schools-cas",
  TAPX: "http://www.tap-x.com/",
};

//Blob storage folder with the page videos (see SETUP.md)
// eslint-disable-next-line no-undef
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;

export const LOADING_STATE = {
  NOT_LOADING: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

export const LS_ITEM = {
  LOGIN: "ls_1",
  CONTACT_SEND: "ls_2",
  CHECKOUT: "ls_3",
  ORDER_STATUS: "ls_4",
  PRODUCTS: "ls_5",
  SUBSCRIBE: "ls_6",
};

export const LS_ITEM_ADMIN = {
  SUMMARY_LOAD: "lsa_1",
  ORDERS_LOAD: "lsa_2",
  ORDER_LOAD: "lsa_3",
  ORDER_SAVE: "lsa_4",
  EXPORT: "lsa_5",
  PASSWORD_SAVE: "lsa_6",
  PRODUCTS_LOAD: "lsa_7",
  PRODUCT_LOAD: "lsa_8",
  PRODUCT_SAVE: "lsa_9",
  PRODUCT_DELETE: "lsa_10",
  IMAGES_UPDATE: "lsa_11",
  SUBSCRIBERS_LOAD: "lsa_12",
};

export const NOTIF_TYPE = {
  STANDARD: 0,
  ERROR: 1,
  SUCCESS: 2,
};

export const PAYMENT_STATUS = {
  PENDING: "Pending",
  PAID: "Paid",
  FAILED: "Failed",
  CANCELLED: "Cancelled",
  REFUNDED: "Refunded",
};

export const FULFILMENT_STATUS = {
  NEW: "New",
  SCHEDULED: "Scheduled",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
};

export const CONTACT_INTERESTS = [
  "Interested in an activity",
  "I would like to volunteer",
  "I have a question",
];
